import React from 'react';
import SecondsTrendWidget, { TrendWidgetProps } from './SecondsTrendWidget';

// Sourced from POST /api/widgets/key-metrics widget type 11 (TCX-6116); `value` is AHT in whole seconds.
const AverageHandlingTimeTrendWidget: React.FC<TrendWidgetProps> = (props) => (
  <SecondsTrendWidget
    {...props}
    title="Average Handle Time Trend"
    description="The pattern of average handled time by the agents within the given time."
    tooltipLabel="Time"
  />
);

export default AverageHandlingTimeTrendWidget;
